<template lang="html">
  
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
<g>
  <path :fill="colors.basic" d="M20.8,6.3H2.1C0.9,6.3,0,5.3,0,4.2s0.9-2.1,2.1-2.1h18.8c1.2,0,2.1,0.9,2.1,2.1S22,6.3,20.8,6.3z"/>
  <path :fill="colors.basic" d="M20.8,16.7H2.1c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1h18.8c1.2,0,2.1,0.9,2.1,2.1S22,16.7,20.8,16.7z"/>
  <path :fill="colors.basic" d="M20.8,27.1H2.1C0.9,27.1,0,26.2,0,25s0.9-2.1,2.1-2.1h18.8c1.2,0,2.1,0.9,2.1,2.1S22,27.1,20.8,27.1z"/>
  <path :fill="colors.basic" d="M20.8,37.5H2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1h18.8c1.2,0,2.1,0.9,2.1,2.1S22,37.5,20.8,37.5z"
    />
  <path :fill="colors.basic" d="M20.8,47.9H2.1C0.9,47.9,0,47,0,45.8s0.9-2.1,2.1-2.1h18.8c1.2,0,2.1,0.9,2.1,2.1S22,47.9,20.8,47.9z"/>
  <path :fill="colors.basic" d="M47.9,6.3H29.2c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1h18.7C49.1,2.1,50,3,50,4.2S49.1,6.3,47.9,6.3z"/>
  <path :fill="colors.basic" d="M47.9,16.7H29.2c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1h18.7c1.2,0,2.1,0.9,2.1,2.1S49.1,16.7,47.9,16.7z"/>
  <path :fill="colors.basic" d="M47.9,27.1H29.2c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1h18.7c1.2,0,2.1,0.9,2.1,2.1S49.1,27.1,47.9,27.1z"/>
  <path :fill="colors.basic" d="M47.9,37.5H29.2c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1h18.7c1.2,0,2.1,0.9,2.1,2.1
    C50,36.6,49.1,37.5,47.9,37.5z"/>
  <path :fill="colors.basic" d="M47.9,47.9H29.2c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1h18.7c1.2,0,2.1,0.9,2.1,2.1S49.1,47.9,47.9,47.9z"/>
</g>
</svg>


</template>

<script lang="js">
  
  import {mapGetters} from 'vuex';

  export default  {
    name: 'download-doc',
    props: [],
    computed : {
      ...mapGetters({
        colors : 'basicColors'
      })
    }
}
</script>

<style scoped lang="scss">
  .add {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/icons/columnas.vue